import { sstPreviewUrl } from "./sstPreviewUrl";

export const URL_THE_WORD = sstPreviewUrl(
  process.env.NEXT_PUBLIC_THE_WORD_ORIGIN,
  "the-word",
);

export const URL_THE_WORD_IMAGE =
  "https://images.hallow.app/games/the-word/0_l.webp";
